export default "__VITE_ASSET__Dddn_6RW__"